import { PartsDiagramByModelDescriptionProps } from '../types';
import { CatHeading } from '@blocks-react/components/Heading';

export const PartsDiagramByModelDescription = ({
  children
}: PartsDiagramByModelDescriptionProps) => {
  return <CatHeading variant="body">{children}</CatHeading>;
};
